import { API_URL } from '@/constants/api';
import { readJson } from '@/shared/utils/json';
import { useEffect, useState } from 'react';
import type { Customer } from '../types';

export const useCustomerDetail = (shopifyCustomerId: string) => {
  const [customer, setCustomer] = useState<Customer | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCustomer = async () => {
      if (!shopifyCustomerId) return;

      setLoading(true);
      setError(null);

      try {
        const response = await fetch(`${API_URL}/admin/customers/${shopifyCustomerId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          if (response.status === 404) {
            throw new Error('Customer not found');
          }
          throw new Error('Failed to fetch customer');
        }

        const data = await readJson<Customer>(response);
        setCustomer(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        setCustomer(null);
      } finally {
        setLoading(false);
      }
    };

    void fetchCustomer();
  }, [shopifyCustomerId]);

  return {
    customer,
    loading,
    error,
    refetch: () => {
      if (shopifyCustomerId) {
        const fetchCustomer = async () => {
          setLoading(true);
          setError(null);
          try {
            const response = await fetch(`${API_URL}/admin/customers/${shopifyCustomerId}`, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                'Content-Type': 'application/json',
              },
            });
            if (!response.ok) throw new Error('Failed to fetch customer');
            const data = await readJson<Customer>(response);
            setCustomer(data);
          } catch (err) {
            setError(err instanceof Error ? err.message : 'An error occurred');
          } finally {
            setLoading(false);
          }
        };
        void fetchCustomer();
      }
    },
  };
};
